import $ from 'jquery';

  $('.burger-nav').on('click', function() {

    $('.burger-nav')
      .toggleClass('checked');
    $('.c-main-nav')
      .removeClass('no-transition');
    $('.c-main-nav')
      .toggleClass('transform');
    $('.soft-overlay')
      .removeClass('no-transition');
    $('.soft-overlay')
      .toggleClass('opacity');
    $('html')
      .toggleClass('no-scroll');
  });

  $('.c-main-nav__link').on('click', function() {

    $('.burger-nav')
      .toggleClass('checked');
    $('.c-main-nav')
      .removeClass('no-transition');
    $('.c-main-nav')
      .toggleClass('transform');
    $('.soft-overlay')
      .removeClass('no-transition');
    $('.soft-overlay')
      .toggleClass('opacity');
    $('html')
      .toggleClass('no-scroll');
  });

  $('.c-main-nav__small-link').on('click', function() {

    $('.burger-nav')
      .toggleClass('checked');
    $('.c-main-nav')
      .toggleClass('transform');
    $('.soft-overlay')
      .toggleClass('opacity');
    $('html')
      .toggleClass('no-scroll');
  });


// WEBPACK FOOTER //
// ./wp/wp-content/themes/brockmeyer-chisel/src/scripts/additional/navigation.js